/*=========================================================================================
  File Name: moduleSigepGetters.js
  Description: Sigep Module Getters
==========================================================================================*/


export default {

  info: (state) => state.info


}
